import {PubSub} from '@mamdev/cad.static-next-lib';

/**
 * Subscribe to events
 * @param {string} message
 * @param {*} data
 */
function subscribe(message, data) {
  PubSub.subscribe(message, data);
}

/**
 * Utility functions concerning tracking
 */
class Tracking {
  /**
   * Initializes the service
   */
  initialize() {
    try {
      subscribe('mcomSitestat', (/** @type {string} */ url) => {
        console.log('tracking', 'mcomSitestat', url);
        this.mcomSitestat(url, '', true, true);
      });

      subscribe('gallery:brain', () => {
        console.log('tracking', 'gallery:brain');
        this.countWAPI('', '', false, false);
      });

      subscribe('video:sendTrackingPixel', (/** @type {object} */ videoTrackingPixel) => {
        console.log('tracking', 'video:sendTrackingPixel', videoTrackingPixel);
        this.mcomSitestat(videoTrackingPixel, '', true, true);
      });

      subscribe('welcomeback:open', data => {
        console.log('tracking', 'welcomeback:open', data);
        this.trackWelcomebackEvent('open', data);
      });

      subscribe('welcomeback:close', data => {
        console.log('tracking', 'welcomeback:close', data);
        this.trackWelcomebackEvent('close', data);
      });

      subscribe('welcomeback:teaserClick', data => {
        console.log('tracking', 'welcomeback:teaserClick', data);
        this.trackWelcomebackEvent('articleteaser', data);
      });

      subscribe('welcomeback:hideForever', data => {
        console.log('tracking', 'welcomeback:hideForever', data);
        this.trackWelcomebackEvent('dontShowAgain', data);
      });

      subscribe('gallery:gtmEvent', (/** @type {object} */ params) => {
        console.log('tracking', 'gallery:gtmEvent', params);

        if (typeof window['dataLayer'] === 'object') {
          window['dataLayer']['push']({
            'event': params.eventName,
            'galleryPageUrl': params.pageUrl
          });
        }
      });
      this.trackOptOut();
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * gets the GET parameter
   * @param {string} href
   * @return {string}
   */
  getGetParamDelimiter(href) {
    const h = href ? href : window.location.href;
    return (h.indexOf('?') > -1) ? '&' : '?';
  }

  /**
   * Shows the next slide
   * @param {string} param
   * @param {string} newHash
   * @param {boolean} ref
   * @param {boolean} processHash
   * @return {any}
   */
  countWAPI(param, newHash, ref, processHash) {
    console.log('tracking', 'countmeinbro');

    if (typeof window['ui']['jsCountUrl'] === 'undefined') {
      return false;
    }

    const jsCountUrl = window['ui']['jsCountUrl'];
    let paramNew = '';

    if (param && param !== '') {
      paramNew = this.getGetParamDelimiter(jsCountUrl) + param;

      if (jsCountUrl.indexOf('_page=1') > -1) { // multi paged
        paramNew = jsCountUrl.replace('_page=1', paramNew);
      }
    }

    this.mcomSitestat(jsCountUrl + paramNew, newHash, ref, processHash);
  }

  /**
   * sets the tracking pixel
   * @param {string} nsUrl
   * @param {string} newHash
   * @param {boolean} ref
   * @param {boolean} processHash
   */
  mcomSitestat(nsUrl, newHash, ref, processHash) {
    console.log('tracking', 'mcomSitestat');

    const trackingURL = this.getTrackingURL(nsUrl, newHash, ref, processHash);
    /*
    if (window.navigator.sendBeacon) {
      window.navigator.sendBeacon(trackingURL);
    } else {
      (document.createElement('img')).src = trackingURL;
    }
    */
    (document.createElement('img')).src = trackingURL;
  }

  /**
   * return timestamp string for tracking
   * @return {string}
   */
  getTimestamp() {
    const now = new Date();
    const month = now.getMonth() + 1;
    const date = now.getDate();
    const hour = now.getHours();
    const minute = now.getMinutes();
    let year = now.getFullYear();
    let getMonth = '';
    let getDate = '';
    let getHours = '';
    let getMinutes = '';

    if (year < 1000) {
      year += 1900;
    }

    if (month < 10) {
      getMonth = '0' + month.toString();
    }

    if (date < 10) {
      getDate = '0' + date.toString();
    }

    if (hour < 10) {
      getHours = '0' + hour.toString();
    }

    if (minute < 10) {
      getMinutes = '0' + minute.toString();
    }
    return year + getMonth + getDate + getHours + getMinutes;
  }

  /**
   * gets the Tracking URL
   * @param {string} nsUrl
   * @param {string} newHash
   * @param {boolean} ref
   * @param {boolean} processHash
   * @return {string}
   */
  getTrackingURL(nsUrl, newHash, ref, processHash) {
    console.log('tracking', 'getTrackingUrl function');

    // old mcomSitestat function
    let trackingConsent = false;

    if (window['ui']['permissions'] && window['ui']['permissions']['brainTracking']) {
      trackingConsent = true;
    }

    // console.log('tracking consent: ' + trackingConsent);

    if (trackingConsent) {
      const nsScreen = window.screen;
      if (nsScreen) {
        nsUrl += '&wa_p_sr=' + nsScreen['width'] + 'x' + nsScreen['height'];
      }
      const vpw = document.documentElement.clientWidth;
      const vph = document.documentElement.clientHeight;
      nsUrl += '&wa_p_vp=' + vpw + 'x' + vph;
    }

    nsUrl += '&wa_output=' + window['ui']['viewportSize'];

    nsUrl += '&wa_t=' + this.getTimestamp();

    // evaluate hash
    let hash = '';
    const hashIdent = '#.';
    if (newHash) {
      hash = newHash;
    } else {
      hash = window['location']['hash'];
    }
    if (processHash) {
      if (hash.indexOf(hashIdent) > -1) {
        let hashArray = [];
        let hashUrl = '';
        hash = hash.replace(hashIdent, '');
        hashArray = hash.split('-');
        for (let i = 0; i < 4; i++) {
          hashUrl += '&c_id_' + (i + 1).toString() + '=' + (typeof hashArray[i] !== 'undefined' ? hashArray[i] : 'undef');
        }
        nsUrl += hashUrl;
      }
    }

    // adblocker?
    nsUrl += '&adblock=' + (window['ui']['_noadblocker'] ? '0' : '1');

    // old .sitestat function
    const d = document;
    const waPixelUrl = nsUrl + '&ns__t=' + (new Date().getTime());
    nsUrl = waPixelUrl + '&ns_c=' + (d['characterSet'] ? d['characterSet'] : d['defaultCharset'])
      + '&ns_jspageurl=' + encodeURIComponent(d['URL']);
    if (ref) {
      // the original referrer saved before the user was redirected to the consent page
      let originalReferrer = '';
      if (typeof (sessionStorage) !== 'undefined') {
        originalReferrer = sessionStorage.getItem('originalReferrer');
      }

      if (originalReferrer !== '') {
        // since the 'originalReferrer' is set in the inline-redirect script, we must delete it here
        // otherwise the same referrer will be taken for all subsequent page visits
        sessionStorage.removeItem('originalReferrer');
      } else {
        originalReferrer = d['referrer'];
      }

      nsUrl += '&ns_referrer=' + encodeURIComponent(originalReferrer);
    }

    return nsUrl;
  }

  /**
   * tracking optOut
   */
  trackOptOut() {
    if (!window['ui']) {
      return;
    }
    const ooUrl = window['ui']['brainOptOutTransferUrl'];
    if (ooUrl) {
      // (new Image()).src = ooUrl;
      /*
      if (window.navigator.sendBeacon) {
        window.navigator.sendBeacon(ooUrl);
      } else {
        (document.createElement('img')).src = ooUrl;
      }
      */
      (document.createElement('img')).src = ooUrl;
    }
  }

  /**
   * tracking for welcomebacklayer events
   * @param {string} event
   * @param {Object} data
   */
  trackWelcomebackEvent(event, data) {
    console.log('tracking', 'trackwelcome event function');
    try {
      const jsCountUrl = window['ui']['jsCountUrl'];

      if (!jsCountUrl) {
        return;
      }

      let trackingUrl = this.getTrackingURL(jsCountUrl, '', false, false);
      let cid1;
      const cid2 = data['type'];
      const cid3 = event;
      let cid4;

      if (window['ui']['pageinfo']) {
        cid1 = window['ui']['pageinfo']['coremid'];
      }

      if (event === 'articleteaser') {
        cid4 = 0;
      }

      trackingUrl += '&c_id_1=' + cid1;
      trackingUrl += '&c_id_2=' + cid2;
      trackingUrl += '&c_id_3=' + cid3;
      trackingUrl += '&c_id_4=' + cid4;

      /*
      if (window.navigator.sendBeacon) {
        window.navigator.sendBeacon(trackingUrl);
      } else {
        (document.createElement('img')).src = trackingUrl;
      }
      */
      (document.createElement('img')).src = trackingUrl;
    } catch (e) {
      console.error(e);
    }
  }
}

export default new Tracking();
